import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs/lib/defs/CHEVRON_RIGHT__16';
import {SVGIcon} from '@homeaway/react-svg';

export class CancelTripModalReason extends Component {
    static propTypes = {
        category: PropTypes.string,
        onClick: PropTypes.func,
        reason: PropTypes.shape({
            reason: PropTypes.string,
            text: PropTypes.string,
        }),
    };

    static defaultProps = {
        onClick: () => {},
        reason: {},
    };

    onClick = (event) => {
        const {onClick, reason} = this.props;

        event.preventDefault();
        onClick(reason);
    };

    render() {
        return (
            <div className="panel--cancel-trip">
                <a
                    className={'panel--cancel-trip_link text-default'}
                    href={''}
                    onClick={this.onClick}
                >
                    <div>{this.props.reason.text}</div>
                    <span className="text-link">
                        <SVGIcon markup={CHEVRON_RIGHT__16} useFill />
                    </span>
                </a>
            </div>
        );
    }
}
